<template>
  <modals-request
    v-model="payload"
    :request-class="proxyRequest('handleStatus')"
    :btn-attrs="attrs"
    :disabled-send="disabled"
    :config-swal="config"
    title="Alterar status de cadastro do cliente?"
    label="Alterar cadastro"
    persistent
    @success="success($event)"
  >
    <form-group>
      <v-row class="pt-2">
        <v-col cols="12">
          <input-select
            id="input:situacaoCadastral"
            v-model="payload.situacaoCadastral"
            label="Status do cadastro"
            :rules="[requiredRule]"
            :items="registerOptions"
            clearable
            outlined
          />
        </v-col>
      </v-row>
      <v-row class="pt-2">
        <v-col cols="12">
          <v-textarea
            id="input:motivoSituacaoCadastral"
            v-model="payload.motivoSituacaoCadastral"
            label="Motivo da alteração"
            :rules="[requiredRule, minLength(10)]"
            rows="6"
            counter
            outlined
          />
        </v-col>
      </v-row>
    </form-group>
  </modals-request>
</template>

<script>
import AnalysisTableButtonsMixin from 'Modules/contacard/analysisTable/components/buttons/AnalysisTableButtonsMixin';
import ClientRegisterEnum from '@/app/arch/enums/ClientRegisterEnum';

export default {
  name: 'ClientRegisterActions',
  mixins: [AnalysisTableButtonsMixin],
  data: () => ({
    payload: {
      clienteId: '',
      situacaoCadastral: '',
      motivoSituacaoCadastral: '',
    },
    config: {
      successMessage: 'Sucesso ao alterar situação cadastral do cliente!',
      errorMessage: 'Falha ao alterar situação cadastral do cliente!',
    },
    registerOptions: ClientRegisterEnum,
  }),
  computed: {
    attrs() {
      return {
        color: 'success',
        outlined: true,
        id: 'openModal',
        ...this.$attrs,
      };
    },
    hasReason() {
      return this.payload.motivoSituacaoCadastral.length >= 10;
    },
    hasRegisterOption() {
      return this.payload.situacaoCadastral !== '';
    },
    disabled() {
      return !this.hasId || !this.hasReason || !this.hasRegisterOption;
    },
  },
};
</script>
